import * as React from 'react';
import { StyleSheet, Pressable, Platform } from 'react-native';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import {
  isTablet,
  Space,
  formatDate,
  Card,
  Text
} from 'secullum-react-native-ui';
import {
  getCorStatus,
  getIconeStatus,
  getLarguraCampoData,
  getTamanhoFonte
} from '../containers/InconsistenciasContainer';
import { getTheme } from '../modules/layout';
import { isHighResolution } from '../modules/layout';
import { InconsistenciasDados } from '../modules/types';

interface Props {
  inconsistencia: InconsistenciasDados;
  inconsistenciaNativeId?: string;
  exibirSeparador: boolean;
  onNavigate: () => void;
}

class InconsistenciaLinha extends React.Component<Props> {
  render() {
    const { inconsistencia, exibirSeparador, inconsistenciaNativeId } =
      this.props;

    const iconeInconsistencia = getIconeStatus(inconsistencia.status);
    const corInconsistencia = getCorStatus(inconsistencia.status);
    const tamanhoFonte = getTamanhoFonte();
    const larguraCampoData = getLarguraCampoData();
    const webDesktop = Platform.OS === 'web' && isHighResolution();

    const formatoData = webDesktop ? 'eeee, dd/MM/yyyy' : 'dd/MM/yy';
    const valorCampoData = formatDate(inconsistencia.data, formatoData);

    return (
      <>
        {exibirSeparador && <Space height={10} />}
        <Card nativeID={inconsistenciaNativeId}>
          <Card.Section>
            <Pressable
              style={({ pressed }) => [
                { opacity: pressed ? 0.7 : 1 },
                styles.linhaTouchable
              ]}
              onPress={() => this.props.onNavigate()}
            >
              <Text
                bold
                flex={webDesktop ? 2 : undefined}
                size={tamanhoFonte}
                style={[styles.linhaText, { width: larguraCampoData }]}
                nativeID="inconsistencia-linha-data"
              >
                {valorCampoData}
              </Text>
              <Text
                bold
                flex={2}
                size={tamanhoFonte}
                style={styles.linhaText}
                nativeID="inconsistencia-linha-tipo"
              >
                {inconsistencia.tipo}
              </Text>
              <Text
                bold
                flex={1.5}
                size={tamanhoFonte}
                style={styles.linhaText}
                nativeID="inconsistencia-linha-horas"
              >
                {inconsistencia.horas || '-'}
              </Text>
              <Text
                bold
                flex={3}
                size={tamanhoFonte}
                align="center"
                style={[
                  styles.linhaText,
                  { width: Platform.OS == 'web' ? 65 : isTablet() ? 70 : 60 }
                ]}
                nativeID="inconsistencia-linha-justificativa"
              >
                {inconsistencia.justificativa || '-'}
              </Text>
              <FontAwesome
                testID={iconeInconsistencia}
                name={iconeInconsistencia}
                color={corInconsistencia}
                nativeID="inconsistencia-linha-status"
                size={20}
                style={[
                  styles.icon,
                  {
                    width: Platform.OS == 'web' || isTablet() ? 50 : 40,
                    flex: webDesktop ? 1 : undefined
                  }
                ]}
              />
            </Pressable>
          </Card.Section>
        </Card>
      </>
    );
  }
}

const theme = getTheme();

const styles = StyleSheet.create({
  linhaTouchable: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1
  },
  linhaText: {
    paddingRight: 5,
    ...(Platform.OS === 'web' ? { wordBreak: 'break-all' } : {}),
    color: theme.textColor1
  },
  icon: {
    textAlign: 'center'
  }
});

export default InconsistenciaLinha;
